<template>
  <div class="organizations-wrap">
    <div class="mb-0 mt-5">
      <h2 class="headline">Advertisers</h2>
    </div>
    <v-container class="mb-4 pa-0">
      <v-row class="wrap">
        <div class="col-sm-6 col-xl-4">
          <v-text-field
            class="inv-search-field mt-0"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
            v-model="search"
            @input="typing = true"
          >
          </v-text-field>
        </div>
      </v-row>
    </v-container>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{'items-per-page-options': [10, 20]}"
        mobile-breakpoint="100"
        class="table-org my-sticky-last-column-table"
      >
        <template v-slot:item="{item}">
          <tr class="items-body-row">
            <td>
              <span v-if="!no_data.includes(item.id)">{{ item.id }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.name)">{{ item.name }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.email)">{{ item.email }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.company_phone)">{{ item.company_phone }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <span v-if="!no_data.includes(item.website)">{{ item.website }}</span>
              <em v-else class="grey--text">No data</em>
            </td>
            <td>
              <v-flex style="min-width: 125px;">
                <v-tooltip top class="mb-2">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click="view(item.id, item.name)"
                      icon
                      class="mx-0"
                      color="primary"
                    >
                      <v-icon>mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>View</span>
                </v-tooltip>
                <v-tooltip top class="mb-2" v-if="item.status=='pending'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      v-on="on"
                      @click="$root.$emit('ApproveOrganization', item)"
                      icon
                      class="mx-0"
                      color="primary"
                    >
                      <v-icon>mdi-briefcase-check</v-icon>
                    </v-btn>
                  </template>
                  <span>Approve</span>
                </v-tooltip>
              </v-flex>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <approve-advertiser @done="initialize"></approve-advertiser>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import ApproveAdvertiser from "./ApproveAdvertiser"

export default {
  name: 'Organizations',
  components: {
    ApproveAdvertiser
  },
  data: () => ({
    no_data: [null, "", undefined, "null"],
    headers: [
      { text: "ID", value: "id", sort_column: 0 },
      { text: "Name", value: "name", sort_column: 1 },
      { text: "Advertiser email", value: "email", sortable: false },
      { text: "Company Phone", value: "company_phone", sortable: false },
      { text: "Website", value: "website", sortable: false },
      { text: "Actions", value: "details", sortable: false, align: "left" }
    ],
    items: [],
    totalItems: 0,
    search: "",
    options: {},
    loading: false,
    tableData: {
      draw: 0,
      length: 10,
      search: "",
      page: 0,
      column: 0,
      dir: "asc"
    },
    serverValidation: true,
    serverValidationMessage: "Oops something went wrong...",
    server_errors: {}
  }),
  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        // this.options.page = 1;
        this.initialize();
      }
    }, 1000)
  },
  mounted() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.loading = true;
      const { sortBy, descending, page, itemsPerPage } = this.options;
      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        this.headers.some(i => i.value === sortBy && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy
        ).sort_column;
      }
      this.tableData.dir = descending === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      ApiService.get("/admin/organizations", this.tableData)
        .then(response => {
          this.draw++
          this.items = response.data.organizations.data
          this.totalItems = response.data.organizations.total
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          console.log(error.message);
        });
    },
    view(id, name) {
      this.$router.push(`/advertiser/${id}/${encodeURIComponent(name)}/details`);
    }
  }
}
</script>
